<template>
  <div class="enrollment">
    <Form ref="optionForm" :model="searchCondition" :label-width="70" inline>
      <FormItem label="用户账号">
        <Input
          type="number"
          v-model="searchCondition.mobile"
          placeholder="请输入用户账号，即手机号"
          style="width: 200px"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="提交时间">
        <Date-picker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          @on-change="onDateRange"
          style="width: 280px"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>

      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>

    <div>
      <Button type="primary" @click="onExport()" class="btn-margin-right">
        批量导出
      </Button>
    </div>

    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/course/enrollments"
        :search="searchCondition"
        :rowsFormatter="onRowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.real_name"></span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <!-- <Button type="text" size="small" @click="onEdit(row)">编辑</Button> -->
            <!-- <span>-</span> -->
            <Button type="text" size="small" @click="onDelete(row)">
              删除
            </Button>
          </div>
        </template>
      </Grid>
    </div>

    <ExportsModal
      title="导出学籍信息"
      :type="6"
      :params="searchCondition"
      v-model="showExportModal"
      @onSuccess="onWatch"
    />
  </div>
</template>

<script>
import ExportsModal from "@/components/ExportsModal";

export default {
  name: "enrollments",
  components: {
    ExportsModal,
  },
  data() {
    return {
      showExportModal: false,
      searchCondition: {
        mobile: "",
        init: function () {
          this.mobile = "";
        },
      },
      tableColumns: [
        {
          title: "用户账号",
          key: "mobile",
          align: "center",
          minWidth: 150,
        },
        {
          title: "用户名",
          key: "nickname",
          align: "center",
          minWidth: 150,
        },

        { title: "课程", key: "course_name", align: "center", minWidth: 100 },
        {
          title: "姓名",
          key: "real_name",
          align: "center",
          minWidth: 100,
        },
        {
          title: "身份证号",
          key: "identity_card",
          align: "center",
          minWidth: 100,
        },
        {
          title: "学号",
          key: "student_number",
          align: "center",
          minWidth: 100,
        },
        {
          title: "QQ",
          key: "qq_number",
          align: "center",
          minWidth: 100,
        },
        {
          title: "推荐人",
          key: "referrer",
          align: "center",
          minWidth: 100,
        },
        {
          title: "地址",
          key: "address",
          align: "center",
          minWidth: 100,
        },

        {
          title: "付款渠道",
          key: "payment_channel",
          align: "center",
          minWidth: 100,
        },

        {
          title: "获悉渠道",
          key: "channel",
          align: "center",
          minWidth: 100,
        },

        {
          title: "浏览器",
          key: "browser",
          align: "center",
          minWidth: 100,
        },
        {
          title: "操作系统",
          key: "operating_system",
          align: "center",
          minWidth: 100,
        },
        {
          title: "IP地址",
          key: "ip_address",
          align: "center",
          minWidth: 100,
        },

        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 150,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right",
        },
      ],
      selectRows: [],
    };
  },
  created() {},
  methods: {
    // on-event
    onRowsFormatter(rows) {
      rows.forEach((i) => {
        i.updated_at = this.$pub.timestampToTime(i.updated_at);
      });
    },
    onDateRange(range) {
      this.searchCondition.created_start = range[0];
      this.searchCondition.created_end = range[1];
    },
    onExport() {
      this.showExportModal = true;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onEdit(row) {
      this.$router.push({
        name: "EnrollmentsEdit",
        query: {
          id: row.id,
        },
      });
    },
    onWatch() {
      this.$router.push({
        name: "Exports",
        query: {
          type: "enrollments",
        },
      });
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除选定的学藉信息吗？",
        onOk: () => {
          this.$http.delete("/api/course/enrollments/" + row.id).then(() => {
            this.$Message.success("删除成功");
            this.$refs.grid.refresh();
          });
        },
      });
    },
  },
};
</script>
